module.exports = __webpack_public_path__ + "static/media/krx-tutorial-01.f87341cb.jpg";